import Banner from "../../components/beauty-treasure/banner";
import Logos from "../../components/beauty-treasure/logos";
import ShopList from "../../components/beauty-treasure/shop-list";
import { banner, logos, products } from "./mock";
import Footer from "../../components/beauty-treasure/footer";
const Home = () => {
  return (
    <div>
      <Banner {...banner} />
      <ShopList products={products} />
      <Logos imgArr={logos} />
      <Footer />
    </div>
  );
};

export default Home;
